export default "__VITE_ASSET__1696da6a__"